export const CREDIENTIALS = [
    {
        email: "instructor.care.library@orcalo.co.uk",
        password: "Instructor@123",
        role: "instructor",
    },
    {
        email: "client.care.library@orcalo.co.uk",
        password: "Client@123",
        role: "client",
    },
    {
        email: "coordinator.care.library@orcalo.co.uk",
        password: "Coordinator@123",
        role: "coordinator",
    },
    {
        email: "carer.care.library@orcalo.co.uk",
        password: "Carer@123",
        role: "carer",
    },
    {
        email: "admin.care.library@orcalo.co.uk",
        password: "Admin@123",
        role: "admin",
    },
    {
        email: "super-admin.care.library@orcalo.co.uk",
        password: "SuperAdmin@123",
        role: "superAdmin",
    }
]